export const SUCCESS_GET_PACKAGETYPES = 'SUCCESS_GET_PACKAGETYPES';
export const FAILED_GET_PACKAGETYPES = 'FAILED_GET_PACKAGETYPES';
export const SUCCESS_GET_ALL_BOOKING_STATUS = 'SUCCESS_GET_ALL_BOOKING_STATUS';
export const FAILED_GET_ALL_BOOKING_STATUS = 'FAILED_GET_ALL_BOOKING_STATUS';
export const SUCCESS_GET_BOOKING_STATUS_HISTORY = 'SUCCESS_GET_BOOKING_STATUS_HISTORY';
export const FAILED_GET_BOOKING_STATUS_HISTORY = 'FAILED_GET_BOOKING_STATUS_HISTORY';
export const SUCCESS_SAVE_STATUS_STATUS = 'SUCCESS_SAVE_STATUS_STATUS';
export const FAILED_SAVE_STATUS_STATUS = 'FAILED_SAVE_STATUS_STATUS';
export const SUCCESS_GET_FPS = 'SUCCESS_GET_FPS';
export const FAILED_GET_FPS = 'FAILED_GET_FPS';
export const SUCCESS_GET_STATUS_ACTIONS = 'SUCCESS_GET_STATUS_ACTIONS';
export const FAILED_GET_STATUS_ACTIONS = 'FAILED_GET_STATUS_ACTIONS';
export const SUCCESS_GET_STATUS_DETAILS = 'SUCCESS_GET_STATUS_DETAILS';
export const FAILED_GET_STATUS_DETAILS = 'FAILED_GET_STATUS_DETAILS';
export const SUCCESS_CREATE_STATUS_DETAIL = 'SUCCESS_CREATE_STATUS_DETAIL';
export const SUCCESS_CREATE_STATUS_ACTION = 'SUCCESS_CREATE_STATUS_ACTION';
export const FAILED_CREATE_STATUS_DETAIL = 'FAILED_CREATE_STATUS_DETAIL';
export const FAILED_CREATE_STATUS_ACTION = 'FAILED_CREATE_STATUS_ACTION';
export const SUCCESS_GET_API_BCLS = 'SUCCESS_GET_API_BCLS';
export const FAILED_GET_API_BCLS = 'FAILED_GET_API_BCLS';
export const RESET_FLAG_STATUSHISTORY = 'RESET_FLAG_STATUSHISTORY';
export const RESET_FLAG_APIBCL = 'RESET_FLAG_APIBCL';
export const SET_STATUS_INFO_FILTER = 'SET_STATUS_INFO_FILTER';
export const RESET_STATUS_INFO_FLAG = 'RESET_STATUS_INFO_FLAG';
export const SUCCESS_GET_STATUS_INFO = 'SUCCESS_GET_STATUS_INFO';
export const FAILED_GET_STATUS_INFO = 'FAILED_GET_STATUS_INFO';
export const RESET_PROJECT_NAMES = 'RESET_PROJECT_NAMES';
export const SUCCESS_GET_PROJECT_NAMES = 'SUCCESS_GET_PROJECT_NAMES';
export const FAILED_GET_PROJECT_NAMES = 'FAILED_GET_PROJECT_NAMES';
export const RESET_STORE_BOOKING_LOGS = 'RESET_STORE_BOOKING_LOGS';
export const SUCCESS_GET_EMAIL_LOGS = 'SUCCESS_GET_EMAIL_LOGS';
export const FAILED_GET_EMAIL_LOGS = 'FAILED_GET_EMAIL_LOGS';
export const RESET_EMAIL_LOGS = 'RESET_EMAIL_LOGS';
export const SUCCESS_CREATE_BOOKING_SET = 'SUCCESS_CREATE_BOOKING_SET';
export const FAILED_CREATE_BOOKING_SET = 'FAILED_CREATE_BOOKING_SET';
export const SUCCESS_GET_BOOKING_SETS = 'SUCCESS_GET_BOOKING_SETS';
export const FAILED_GET_BOOKING_SETS = 'FAILED_GET_BOOKING_SETS';
export const SUCCESS_UPDATE_BOOKING_SET = 'SUCCESS_UPDATE_BOOKING_SET';
export const FAILED_UPDATE_BOOKING_SET = 'FAILED_UPDATE_BOOKING_SET';
export const SUCCESS_DELETE_BOOKING_SET = 'SUCCESS_DELETE_BOOKING_SET';
export const FAILED_DELETE_BOOKING_SET = 'FAILED_DELETE_BOOKING_SET';
export const SUCCESS_VALIDATE_BOOKING_SET = 'SUCCESS_VALIDATE_BOOKING_SET';
export const FAILED_VALIDATE_BOOKING_SET = 'FAILED_VALIDATE_BOOKING_SET';
export const RESET_BOOKING_SET_FLAGS = 'RESET_BOOKING_SET_FLAGS';
export const SUCCESS_STATUSHISTORY_SAVE_PU_INFO = 'SUCCESS_STATUSHISTORY_SAVE_PU_INFO';
export const FAILED_STATUSHISTORY_SAVE_PU_INFO = 'FAILED_STATUSHISTORY_SAVE_PU_INFO';
export const SUCCESS_UPDATE_CLIENT_EMPLOYEE = 'SUCCESS_UPDATE_CLIENT_EMPLOYEE';
export const FAILED_UPDATE_CLIENT_EMPLOYEE = 'FAILED_UPDATE_CLIENT_EMPLOYEE';
export const SUCCESS_GET_CLIENT_EMPLOYEES = 'SUCCESS_GET_CLIENT_EMPLOYEES';
export const FAILED_GET_CLIENT_EMPLOYEES = 'FAILED_GET_CLIENT_EMPLOYEES';
export const SUCCESS_CREATE_CLIENT_EMPLOYEE = 'SUCCESS_CREATE_CLIENT_EMPLOYEE';
export const FAILED_CREATE_CLIENT_EMPLOYEE = 'FAILED_CREATE_CLIENT_EMPLOYEE';
export const SUCCESS_GET_CLIENT_PRODUCTS= 'SUCCESS_GET_CLIENT_PRODUCTS';
export const FAILED_GET_CLIENT_PRODUCTS = 'FAILED_GET_CLIENT_PRODUCTS';
export const SUCCESS_DELETE_CLIENT_PRODUCTS = 'SUCCESS_DELETE_CLIENT_PRODUCTS';
export const FAILED_DELETE_CLIENT_PRODUCTS = 'FAILED_DELETE_CLIENT_PRODUCTS';
export const SUCCESS_CREATE_CLIENT_PRODUCTS = 'SUCCESS_CREATE_CLIENT_PRODUCTS';
export const FAILED_CREATE_CLIENT_PRODUCTS = 'FAILED_CREATE_CLIENT_PRODUCTS';
export const SUCCESS_GET_ALL_ERRORS = 'SUCCESS_GET_ALL_ERRORS';
export const SUCCESS_UPDATE_CLIENT_PRODUCT = 'SUCCESS_UPDATE_CLIENT_PRODUCT';
export const FAILED_UPDATE_CLIENT_PRODUCT = 'FAILED_UPDATE_CLIENT_PRODUCT';
export const FAILED_GET_ALL_ERRORS = 'FAILED_GET_ALL_ERRORS';
export const SUCCESS_GET_CLIENT_EMPLOYEE = 'SUCCESS_GET_CLIENT_EMPLOYEE';
export const FAILED_GET_CLIENT_EMPLOYEE = 'FAILED_GET_CLIENT_EMPLOYEE';
export const SUCCESS_GET_PALLETS = 'SUCCESS_GET_PALLETS';
export const FAILED_GET_PALLETS = 'FAILED_GET_PALLETS';
export const SUCCESS_CREATE_PALLET = 'SUCCESS_CREATE_PALLET';
export const FAILED_CREATE_PALLET = 'FAILED_CREATE_PALLET';
export const SUCCESS_GET_SCANS = 'SUCCESS_GET_SCANS';
export const FAILED_GET_SCANS = 'FAILED_GET_SCANS';
export const SUCCESS_CREATE_SCAN = 'SUCCESS_CREATE_SCAN';
export const FAILED_CREATE_SCAN = 'FAILED_CREATE_SCAN';
export const SUCCESS_UPDATE_SCAN = 'SUCCESS_UPDATE_SCAN';
export const FAILED_UPDATE_SCAN = 'FAILED_UPDATE_SCAN';
export const SUCCESS_DELETE_SCAN = 'SUCCESS_DELETE_SCAN';
export const FAILED_DELETE_SCAN = 'FAILED_DELETE_SCAN';
export const SUCCESS_GET_LOGS = 'SUCCESS_GET_LOGS';
export const FAILED_GET_LOGS = 'FAILED_GET_LOGS';
export const SUCCESS_FIND_BOOKING = 'SUCCESS_FIND_BOOKING';
export const FAILED_FIND_BOOKING = 'FAILED_FIND_BOOKING';
export const RESET_PAGE_URLS = 'RESET_PAGE_URLS';
export const SUCCESS_GET_CS_NOTES = 'SUCCESS_GET_CS_NOTES';
export const FAILED_GET_CS_NOTES = 'FAILED_GET_CS_NOTES';
export const SUCCESS_CREATE_CS_NOTE = 'SUCCESS_CREATE_CS_NOTE';
export const FAILED_CREATE_CS_NOTE = 'FAILED_CREATE_CS_NOTE';
export const SUCCESS_UPDATE_CS_NOTE = 'SUCCESS_UPDATE_CS_NOTE';
export const FAILED_UPDATE_CS_NOTE = 'FAILED_UPDATE_CS_NOTE';
export const SUCCESS_DELETE_CS_NOTE = 'SUCCESS_DELETE_CS_NOTE';
export const FAILED_DELETE_CS_NOTE = 'FAILED_DELETE_CS_NOTE';
export const RESET_QUICK_PRICING = 'RESET_QUICK_PRICING';
export const SUCCESS_GET_QUICK_PRICING = 'SUCCESS_GET_QUICK_PRICING';
export const FAILED_GET_QUICK_PRICING = 'FAILED_GET_QUICK_PRICING';
export const SET_FETCH_BSD_ORDER_FLAG = 'SET_FETCH_BSD_ORDER_FLAG';
export const SUCCESS_FETCH_BSD_ORDER = 'SUCCESS_FETCH_BSD_ORDER';
export const FAILED_FETCH_BSD_ORDER = 'FAILED_FETCH_BSD_ORDER';
export const SET_FETCH_JASONL_ORDER_FLAG = 'SET_FETCH_JASONL_ORDER_FLAG';
export const SUCCESS_FETCH_JASONL_ORDER = 'SUCCESS_FETCH_JASONL_ORDER';
export const FAILED_FETCH_JASONL_ORDER = 'FAILED_FETCH_JASONL_ORDER';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';



// WEBPACK FOOTER //
// ./src/state/constants/extraConstants.js